import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import {
  Routes,
  Route,
  BrowserRouter,
} from "react-router-dom";
//import * as serviceWorker from './serviceWorker';
import CustomFormNew from './components/CustomFormNew';
import CONST from './config/configFeria.json';
import Lista from "./components/Lista";
import UploadFair from "./components/UploadFair";
import UpdateFair from './components/UpdateFair';

function App() {
  //Distintas rutas de la aplicación
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path={'/'}
          element={<div>Planificador CMS</div>}>
        </Route>
        <Route
          path={`/ferias-cms`}
          element={<Lista publicUrl={process.env.BACKEND_APPFERIAS_URL} />}>
        </Route>
        <Route
          path={`/ferias-cms/editar/:id`}
          element={<CustomFormNew standalone={true} fileTxt={'fitur.txt'} fileJson={process.env.REACT_APP_FILE_JSON_NAME} output={CONST.FILE_OUTPUT_JSON_PATH} url={process.env.REACT_APP_BACKEND_URL} publicUrl={'/ferias-cms'}/>}>
        </Route>
        <Route path={`/ferias-cms/cargar-feria/:id`} element={<UploadFair />} />
        <Route path={`/ferias-cms/actualizar-feria/:id`} element={<UpdateFair />} />
      </Routes>
      </BrowserRouter>
  );
}

export default App;
